class ApoReloadHandler {
  constructor() {
    this.isActive = false;
    this.currentUrl = window.location.href;
    this.originalReplaceState = null;
    this.checkCount = 0;

    this.startWaiting();
  }

  startWaiting() {
    this.checkForApo();
  }

  checkForApo() {
    this.checkCount++;

    if (this.hasActiveProductApp()) {
      this.activate();
      return;
    }

    // Warte und prüfe erneut (maximal 10 Sekunden)
    if (this.checkCount < 20) {
      setTimeout(() => this.checkForApo(), 500);
    }
  }

  hasActiveProductApp() {
    const appBlock = document.getElementById('mw-apo-app-block');
    return appBlock && appBlock.children.length > 0;
  }

  activate() {
    if (this.isActive) return;

    this.isActive = true;
    this.deactivateBuyNow();
    this.setupUrlWatcher();
  }

  setupUrlWatcher() {
    this.originalReplaceState = history.replaceState;

    history.replaceState = (...args) => {
      const oldUrl = this.currentUrl;
      const newUrl = args[2] || window.location.href;

      // Führe ursprüngliche Funktion aus
      this.originalReplaceState.apply(history, args);

      // Prüfe ob neu laden nötig
      if (this.shouldReload(oldUrl, newUrl)) {
        setTimeout(() => window.location.reload(), 70);
      }

      this.currentUrl = newUrl;
    };
  }

  shouldReload(oldUrl, newUrl) {
    return this.isActive && oldUrl !== newUrl && newUrl.includes('variant=');
  }

  deactivateBuyNow() {
    // hide buynow / paypal button bc. app may not support it correctly
    const productFormButtons = document.querySelector('.product-form__buttons');
    const nonAddToCartButton = productFormButtons?.querySelector(' button:not(.product-form__submit)');
    const shopifyPaymentButton = productFormButtons?.querySelector(' .shopify-payment-button');
    if (nonAddToCartButton) nonAddToCartButton.style.display = 'none';
    if (shopifyPaymentButton) shopifyPaymentButton.style.display = 'none';
  }
}

// Starte Handler
window.apoReloadHandler = new ApoReloadHandler();
